const AUCTION_TYPE_OPTIONS = ['Online Only', 'Live Auction'];
export { AUCTION_TYPE_OPTIONS };
